// Generated from src/img/svg/accessibility.svg

export const Accessibility = (props) => {
  return (
    <svg height="23.96" viewBox="0 0 6.339 6.339" width="23.96" {...props}>
      <circle
        cx="3.178"
        cy="3.434"
        fill="#353535"
        r="3.17"
        transform="translate(-.008 -.264)"
      />
      <g data-name="Ebene 2">
        <g data-name="Ebene 1">
          <path d="M.437.145H5.9v5.464H.437z" fill="none" />
          <g fill="#fffdfd" transform="translate(.437 .145)scale(.22769)">
            <circle cx="12" cy="3.9" r="2" />
            <path d="M10 19.9a2.9 2.9 0 0 1-3-3 2.9 2.9 0 0 1 2-2.8V8.7H5v1.5h2.3v2.5a5 5 0 0 0 2.7 9.2 5 5 0 0 0 4.9-4h-2.1a2.9 2.9 0 0 1-2.8 2" />
            <path d="M19 12.9v-2a6.2 6.2 0 0 1-4.1-1.8l-1.3-1.5a1.5 1.5 0 0 0-.6-.4 2.4 2.4 0 0 0-1.2-.3A2.1 2.1 0 0 0 10 9v5.9a2 2 0 0 0 2 2h5v5h2v-5.5a2 2 0 0 0-2-2h-3V11a8.8 8.8 0 0 0 5 1.9" />
          </g>
        </g>
      </g>
    </svg>
  );
};
